export default "__VITE_ASSET__DaP6vNhU__"